import { render, staticRenderFns } from "./ProductsSidebar.vue?vue&type=template&id=72a7d2b4&scoped=true&"
import script from "./ProductsSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSidebar.vue?vue&type=style&index=0&id=72a7d2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7d2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a7d2b4')) {
      api.createRecord('72a7d2b4', component.options)
    } else {
      api.reload('72a7d2b4', component.options)
    }
    module.hot.accept("./ProductsSidebar.vue?vue&type=template&id=72a7d2b4&scoped=true&", function () {
      api.rerender('72a7d2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/ProductsSidebar.vue"
export default component.exports